import { styled } from '@slal/ui';
import { LoadingDots } from '@slal/ui/animations';
import { breakpointUp } from '@slal/ui/helpers';

export const StyledContent = styled.div`
    h1,
    h2 {
        margin-bottom: ${({ theme }) => theme.space[5]};
    }
    h4 {
        font-weight: 400;
        margin-bottom: ${({ theme }) => theme.space[4]};
    }
`;

export const StyledPageLoadingDots = styled(LoadingDots)`
    display: flex;
    height: 50vh;
    align-items: center;
    justify-content: center;
`;

export const DisplayMobile = styled.div`
    display: block;
    margin-top: 48px;
    ${breakpointUp.md`
        display:none;    
    `}
`;

export const DisplayDesktop = styled.div`
    display: none;
    ${breakpointUp.md`
        display:block;    
    `}
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;
